export const orders = {
  title: '订单',
  orders: '订单',
  resourceName: '订单',
  orderManagement: '订单管理',
  searchCode: {
    label: '按订单号或运单号搜索',
    placeholder: '输入订单号或运单号',
  },
  filter: {
    placeholder: '搜索订单',
    advancedFilter: '高级筛选',
    code: '订单号',
    name: '订单名称',
    subCustomerCode: '子客户代码',
    subCustomerPlaceholder: '子客户代码',
    numberOfPack: '件数',
    customer: '客户',
    fromWarehouse: '发货仓库',
    toWarehouse: '到货仓库',
    createdAtFrom: '创建日期从',
    createdAtTo: '创建日期至',
    clearFilter: '清除筛选',
    search: '搜索',
  },
  fields: {
    id: 'ID',
    code: '代码',
    createdAt: '创建于',
    updatedAt: '更新于',
    status: '状态',
    customerId: '客户ID',
    customerName: '客户名称',
    customerCode: '客户代码',
    orderCode: '订单号',
    ladingCode: '运单号',
    customer: '客户',
    shipments: '货物',
    totalPack: '总包裹数',
    totalVolume: '总体积 (m³)',
    totalWeight: '总重量 (kg)',
    totalNumberOfPack: '总包裹数',
    fee: '费用 (CN¥)',
    orderCreate: '创建订单',
    notes: '备注',
    actions: '操作',
    domesticShippingFee: '国内运输费用',
    towingFee: '拖车费用',
    otherFee: '其他费用',
    createdBy: '创建者',
    isUnofficialWay: '非官方渠道',
  },
  form: {
    ladingCode: {
      label: '运单号',
      helperText: '请输入订单的运单号',
      validate: '请输入运单号',
    },
    notes: {
      label: '客户备注',
      helperText: '请输入客户的备注',
      validate: '请输入客户备注',
    },
    totalNumberOfPack: {
      label: '总包裹数',
      helperText: '请输入订单的总包裹数',
      validate: '请输入总包裹数',
    },
    domesticShippingFee: {
      label: '国内运输费用',
      helperText: '请输入订单的国内运输费用',
      validate: '请输入国内运输费用',
    },
    towingFee: {
      label: '拖车费用',
      helperText: '请输入订单的拖车费用（如适用）',
      validate: '请输入拖车费用',
    },
    otherFee: {
      label: '其他费用',
      helperText: '请输入订单的其他费用（如适用）',
      validate: '请输入其他费用',
    },
    isUnofficialWay: {
      label: '非官方渠道',
      helperText: '该订单的所有货物将不会通过系统计算，并且始终在目的地仓库',
      validate: '请输入非官方渠道',
    },
    sectionOrderInfo: '订单信息',
    sectionFee: '费用 (CNY)',
    placeholderLadingCode: '输入运单号',
    placeholderNotesOptional: '备注（选填）',
    labelShippingFee: '运输费',
    checkboxUnofficialWay: '走小额贸易',
  },
  detail: {
    tabShipments: '货物',
    tabInfo: '基本信息',
    tabPrice: '价格',
    noImages: '暂无图片',
    shipmentsListTitle: '货物列表',
    addShipment: '添加货物',
    duplicateShipment: '复制',
    editShipment: '编辑货物',
    noShipments: '暂无货物',
    totalShipments: '共 {total} 批货物',
    price: {
      columnStt: '序号',
      columnInfo: '信息',
      columnPacks: '件数',
      columnPriceByWeight: '按重量计价',
      columnPriceByVolume: '按体积计价',
      columnFinalPrice: '最终价格',
      pricePerKg: '元/kg',
      pricePerM3: '元/m³',
      priceByWeight: '按重量',
      priceByVolume: '按体积',
      totalShipments: '货物总价：',
      domesticShippingFee: '国内运输费：',
      towingFee: '拖车费：',
      otherFee: '其他费用：',
      total: '合计：',
    },
  },
  inputManual: '手动输入',
  systemCalculation: '系统计算',
  numberOfVolume: '体积数量',
  numberOfWeight: '重量数量',
  domesticShippingFee: '国内运输费用',
  towingFee: '拖车费用',
  otherFee: '其他费用',
  import: {
    button: '导入',
    title: '导入订单',
    description: '选择 XLSX 文件（按照模板格式）。',
    noSheet: '在 Excel 文件中未找到工作表',
    readError: '读取 Excel 文件失败',
    noData: '没有可导入的数据',
    hasError: '导入存在错误。请检查数据。',
    success: '订单导入成功',
    successWithCounts: '订单导入成功。新建: {created}，更新: {updated}',
    failed: '导入失败',
    savedSuccess: '保存成功',
    templateSheetName: '订单导入模板',
    templateFileName: '订单导入模板.xlsx',
    templateSuccess: '模板文件下载成功',
    templateFailed: '下载模板文件失败',
    templateLoading: '正在下载...',
    templateButton: '下载模板',
  },
  export: {
    button: '导出',
    fileName: '订单列表_{date}.xlsx',
    sheetName: '订单列表',
    success: 'Excel 文件导出成功',
    failed: '导出 Excel 文件失败',
    loading: '正在导出...',
    columns: {
      code: '订单号',
      name: '订单名称',
      subCustomerCode: '子客户代码',
      numberOfPack: '件数',
      customerName: '客户',
      fromWarehouseName: '发货仓库',
      toWarehouseName: '到货仓库',
      createdAt: '创建日期',
      updatedAt: '更新日期',
    },
  },
  titles: {
    view: '订单详情',
    show: '查看订单',
    edit: '编辑订单',
    create: '创建订单',
    latestOrders: '最新订单',
    duplicateOrder: '复制订单',
    deleteOrder: '删除订单',
    editOrder: '编辑订单',
    addQuick: '快速添加',
    deleteSelected: '删除已选',
    deleting: '删除中...',
    selectedCount: '已选 {count} 个订单',
  },
  messages: {
    saving: '保存中...',
    savedSuccess: '保存成功',
    loadOrderError: '无法加载订单信息',
    deleteConfirm: '确定要删除此订单吗？相关货物将一并删除。',
    deleteSuccess: '订单已删除',
    deleteError: '删除订单失败',
    bulkDeleteConfirm: '确定删除已选的 {count} 个订单？相关货物将一并删除。',
    bulkDeleteError: '批量删除失败',
    noData: '暂无数据',
    totalOrders: '共 {total} 个订单',
  },
}
